module.exports = __webpack_public_path__ + "static/lab_members-611451d0d4aeb72b340aa997cff2c3a4.webp";